export default __webpack_public_path__ + "static/media/dmsans-regular-webfont.66165f35.woff";